module.exports = __webpack_public_path__ + "img/Painting05.2d868133.png";